'use strict';

angular.module('user')
    .component('validateError', {
        templateUrl: 'js/modules/user/components/validate-error/template.html',
    });
